import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { OfflineService } from './services/offline.service';


@Injectable()
export class OfflineInterceptor implements HttpInterceptor {

  constructor(private offlineService: OfflineService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!navigator.onLine) {
          this.offlineService.storeFailedRequest(req);
        }
        return throwError(error);
      })
    );
  }
}